import {
  type ContratApprentissageDTO,
  type LovCappDTO,
  type VentilationRemunerationDTO,
} from '@/features/api/extranet/dto/Demande/CAPP'
import { idccAutoriseTT } from '@/features/domaine/regles-akto/shared'
import { AnneeFormation } from '@/features/domaine/types/opco/Demande/CAPP'
import { buildDemandeService } from '../buildDemandeService'

export default buildDemandeService<ContratApprentissageDTO, LovCappDTO>({
  dispositif: 'CAPP',
  normaliserData: normaliserData,
})

function normaliserData(data: ContratApprentissageDTO) {
  data.apprenti = data.apprenti ?? ({} as any)
  data.apprenti!.adresse = data.apprenti?.adresse ?? ({} as any)

  data.contrat = data.contrat ?? ({} as any)
  data.contrat!.dureeHebdomadaire = data.contrat?.dureeHebdomadaire ?? ({} as any)

  data.employeur = data.employeur ?? ({} as any)
  data.employeur!.contact = data.employeur?.contact ?? ({} as any)
  data.employeur!.etablissement = data.employeur?.etablissement ?? ({} as any)
  data.employeur!.etablissement!.adresse = data.employeur?.etablissement?.adresse ?? ({} as any)
  data.employeur!.etablissement!.idcc = data.employeur?.etablissement?.idcc ?? ({} as any)
  data.employeur!.etablissement!.naf = data.employeur?.etablissement?.naf ?? ({} as any)
  data.employeur!.secteurEntreprise = data.employeur!.secteurEntreprise ?? 'Prive'

  data.fichiers = data.fichiers ?? []

  data.formation = data.formation ?? ({} as any)

  /* Todo : voir avec Pierrick
  data.formation!.cfaEtablissement = data.formation?.cfaEtablissement ?? null
  data.formation!.cfaEtablissementLieuPrestation = data.formation?.cfaEtablissementLieuPrestation ?? null
  */
  // data.formation!.fraisFactureCfa = data.formation?.fraisFactureCfa ?? ({} as any)
  // data.formation!.fraisSupportesCfa = data.formation?.fraisSupportesCfa ?? []

  data.remuneration = data.remuneration ?? ({} as any)
  if ((data.remuneration!.ventilations?.length ?? 0) === 0) {
    data.remuneration!.ventilations = Array.from(new Array(8), (_x, i) => i)
      .map((i) => Math.floor(i / 2))
      .map(
        (i) =>
          ({
            // Et pas Object.keys(AnneeFormation) ( '1', '2', ...)
            anneeFormation: AnneeFormation[i],
            baseCalcul: null,
            dateRange: null,
            pourcentage: null,
          }) as VentilationRemunerationDTO,
      )
  }

  /* A vérifier */
  /*
  data.representantLegal = data.representantLegal ?? ({} as any)
  data.representantLegal!.adresse = data.representantLegal?.adresse ?? ({} as any)
  data.representantLegal!.representant = data.representantLegal?.representant ?? ({} as any)
  */
  data.tutorat = data.tutorat ?? ({} as any)
  data.tutorat!.maitreApprentissage = data.tutorat?.maitreApprentissage ?? ({} as any)

  if (idccAutoriseTT.includes(data.employeur?.etablissement?.idcc?.code ?? '') && data.typePublic === 'Interimaire')
    data.tutorat!.maitreApprentissageSecondaire ??= ({} as any)
  return data
}
